import React from 'react'
import { Typography, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import InstagramVideo from './InstagramVideo'
import { useModalStore } from '../../../../store/ModalStore'
import { MODAL_STATE } from '../../../../types/modals'
import { trackButtonClick } from '../../../../utils/gtmUtils'
import './TryOut.css'

const { Title, Paragraph } = Typography

const TryOut: React.FC = () => {
    const { t } = useTranslation()
    const { openModal } = useModalStore()

    return (
        <div className="tryitout-container" id="community">
            <div className="tryitout-content">
                {/* Left - Text */}
                <div className="text-container">
                    <Title className="title" level={2}>
                        {t('home.tryOut.title')}
                    </Title>

                    <Paragraph className="paragraph">
                        {t('home.tryOut.description')}
                    </Paragraph>

                    <Button
                        type="primary"
                        size="large"
                        onClick={() => {
                            trackButtonClick('join_community', 'tryout')
                            openModal(MODAL_STATE.JOIN_COMMUNITY)
                        }}
                    >
                        {t('home.tryOut.joinCommunity')}
                    </Button>
                </div>

                {/* Right - Video Player */}
                <InstagramVideo videoUrl="/videos/endless-possibilities.mp4" />
            </div>
        </div>
    )
}

export default TryOut
